/**
 * What was read off a site plan, and the checks run on it. Shown to the owner
 * as they register a plot, and to the administrator who verifies it. The
 * checks inform the person deciding; they do not decide.
 */
const PlanChecks = ({ analysis, title = 'What we read on the site plan' }) => {
  if (!analysis) return null;
  if (analysis.error) {
    return (
      <div className="notice notice-warn">
        <strong>The site plan could not be read automatically.</strong> {analysis.error}
      </div>
    );
  }
  const read = analysis.read || {};
  const facts = [
    ['Village', read.village],
    ['Town', read.town],
    ['Chief', read.chiefName],
    ['Signed on', read.signedOn],
    ['Plot number', read.plotNumber],
    ['Layout', read.layoutName],
    ['Land certificate', read.certificateNumber],
    ['Surveyor', read.surveyorName],
    ['Area on the plan', read.statedAreaSqm ? `${Math.round(read.statedAreaSqm)} m2` : null],
    ['Beacons', read.beacons?.length ? `${read.beacons.length} (${read.coordinateSystem === 'utm' ? `UTM${read.utmZone ? ` zone ${read.utmZone}` : ''}` : 'degrees'})` : null]
  ].filter(([, value]) => value);

  return (
    <div className={`plan-checks is-${analysis.verdict === 'looks_good' ? 'good' : 'attention'}`}>
      <div className="plan-checks-head">
        <strong>{title}</strong>
        <span className={`badge badge-${analysis.verdict === 'looks_good' ? 'good' : 'warn'}`}>
          {analysis.verdict === 'looks_good' ? 'Everything checks out' : 'Needs a closer look'}
        </span>
      </div>
      {facts.length ? (
        <dl className="plan-checks-facts">
          {facts.map(([label, value]) => (
            <div key={label}>
              <dt>{label}</dt>
              <dd>{value}</dd>
            </div>
          ))}
        </dl>
      ) : null}
      <ul className="plan-checks-list">
        {analysis.checks.map((check) => (
          <li key={check.key} className={check.ok ? 'is-ok' : 'is-flag'}>
            <span aria-hidden="true">{check.ok ? '✓' : '!'}</span> {check.message}
          </li>
        ))}
        {(read.issues || []).map((issue) => (
          <li key={issue} className="is-flag">
            <span aria-hidden="true">!</span> {issue}
          </li>
        ))}
      </ul>
      <p className="field-hint">
        Read automatically{analysis.confidence ? ` (${analysis.confidence} confidence)` : ''}. Check every figure against the
        plan itself - our team compares them again before the plot is verified.
      </p>
    </div>
  );
};

export default PlanChecks;
